export default __webpack_public_path__ + "5bc3b276b7e5cd76c9231a86de6fc91b.png";